<template>
  <div
    class="notifications__container"
    :class="{ 'notifications__container--with-banner': hasBanner }"
  >
    <b-col>
      <b-row
        ><b-col cols="10">
          <h3 class="font-weight-bold pt-4">Notifications</h3>
        </b-col>
        <b-col class="pt-2 pl-4"
          ><b-button variant="transparent" class="px-0" @click="$emit('close')"
            ><b-icon icon="x" font-scale="1"></b-icon></b-button></b-col
      ></b-row>
      <b-row>
        <b-col class="pl-3 pt-1 pb-2 d-flex" style="gap: 8px">
          <b-button
            variant="primary"
            class="px-2"
            style="
              height: 34px;
              padding: 0.25rem;
              white-space: nowrap;
              align-items: center;
              display: inline-flex;
              justify-content: center;
            "
            @click="markAllAsRead"
          >
            <span>Mark All As Read</span>
          </b-button>
          <b-button
            variant="outline-danger"
            class="px-2"
            style="
              height: 34px;
              padding: 0.25rem;
              white-space: nowrap;
              align-items: center;
              display: inline-flex;
              justify-content: center;
            "
            @click="clearAllNotifications"
          >
            <span>Clear All</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="pl-3 pt-1 pb-3">
          <b-form-input
            placeholder="Search"
            v-model="searchQuery"
          ></b-form-input>
        </b-col>
      </b-row>
    </b-col>
    <div v-if="filteredNotifications.length > 0" class="notifications__list">
      <b-list-group v-for="notif in pagedItems" :key="notif.id">
        <b-list-group-item
          class="pr-0 py-3 notif-item"
          :class="{
            'unread-invite':
              notif.read === false &&
              notif.type === 'companyinvitenotification',
            unread: notif.read === false,
            'notif-locked': isLockedAccessNotif(notif),
          }"
        >
          <button
            class="notif-delete-btn"
            title="Delete"
            @click.stop="deleteNotification(notif)"
          >
            <b-icon icon="x" font-scale="1" />
          </button>
          <div
            v-if="loadingFileRequestId === notif.id"
            class="notif-loading-overlay"
            role="status"
            aria-live="polite"
          >
            <b-spinner small class="mr-2" />
            <span>Opening…</span>
          </div>
          <b-row>
            <b-col cols="2" class="px-0 pl-2">
              <b-img
                v-if="notif.type === 'expiringfilenotification'"
                center
                class="image"
                :src="fileSrc(notif)"
              ></b-img>
              <div
                v-else-if="notif.type === 'resourceupdatednotification'"
                class="notif-system-icon"
              >
                <b-icon icon="stars" />
              </div>
              <div
                v-else-if="
                  notif.type === 'supervisortimesheetrejectednotification'
                "
                class="notif-system-icon"
              >
                <b-icon icon="clock-history" />
              </div>
              <div
                v-else-if="
                  notifOtwType(notif) === 'otw_resume_request_received'
                "
                class="notif-system-icon"
              >
                <b-icon icon="person-lines-fill" />
              </div>
              <div
                v-else-if="
                  notifOtwType(notif) === 'otw_workforce_invitation_received'
                "
                class="notif-system-icon"
              >
                <b-icon icon="people-fill" />
              </div>
              <b-avatar
                v-else
                variant="primary"
                class="avatar"
                :src="fileSrc(notif)"
              ></b-avatar>
            </b-col>

            <!-- Business admin with no token: company info stays hidden -->
            <b-col
              v-if="isBusinessAdminWithoutToken"
              cols="8"
              class="d-flex flex-column justify-content-center pl-4 text-muted"
            >
              <b-row><b-icon-lock class="mr-1" /> Message locked</b-row>
              <b-row class="small"
                >Token required. Contact your primary admin</b-row
              >
            </b-col>

            <!-- Type: Company Invite -->
            <b-col
              v-else-if="notif.type === 'companyinvitenotification'"
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              @click="
                !isTradieUser && notif.read
                  ? $router.replace({ name: 'tradies' })
                  : null
              "
              ><b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
              <!-- prettier-ignore -->
              <b-row v-if="!notif.read" class="pt-1 justify-content-end" style="gap: 10px">
                <b-button class="slim" variant="success" @click="onRespondInvite(notif, true)">Accept</b-button>
                <b-button class="slim" variant="danger" @click="onRespondInvite(notif, false)">Decline</b-button>
              </b-row>
              <!-- <b-row v-else>Responded</b-row> -->
            </b-col>

            <!-- Type: Mass notification (BA message to employees), and any
                 other company-originated notification (supervisor
                 assignment, supervisor timesheet activity) — all gated the
                 same way while the tradie has no token. -->
            <!-- Locked company notification -->
            <b-col
              v-else-if="
                (notif.type === 'notify' ||
                  notif.type === 'mass_notification' ||
                  notif.type === 'filerequestnotification' ||
                  isTokenGatedCompanyNotif(notif) ||
                  isJobScheduleNotif(notif)) &&
                isLockedTradie
              "
              cols="8"
              class="d-flex flex-column justify-content-center pl-4 text-muted"
            >
              <b-row><b-icon-lock class="mr-1" /> Message locked</b-row>
              <b-row class="small"
                >Token required. Contact Business Admin</b-row
              >
            </b-col>

            <!-- Unlocked mass notification (existing) -->
            <b-col
              v-else-if="
                notif.type === 'notify' || notif.type === 'mass_notification'
              "
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              type="button"
              @click="onMassNotificationClick(notif)"
            >
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Archived user login attempt (BA or Tradie): informational only (id is user id, not file id) -->
            <b-col
              v-else-if="isArchivedAdminLoginAttemptNotification(notif)"
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              tabindex="0"
              @click="markAsRead(notif)"
            >
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Tradie disabled (informational only, BA side): nothing to
                 navigate to — the tradie is globally hidden by User's
                 "blocked" scope while disabled, so any deep link (profile,
                 candidate card) would 404. Click just marks it read. -->
            <b-col
              v-else-if="notif.type === 'tradiedisablednotification'"
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              tabindex="0"
              @click="markAsRead(notif)"
            >
              <b-row><span class="notif-sender">TradiePass</span></b-row>
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Tradie left company (informational only): its payload id is
                 the company id, not a file id, and the tradie is no longer
                 linked, so there's nothing to open. Not clickable — the row's
                 dismiss button clears it. -->
            <b-col
              v-else-if="notif.type === 'tradieleftcompanynotification'"
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
            >
              <b-row><span class="notif-sender">TradiePass</span></b-row>
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Locked file notification: BA has no token for this tradie -->
            <b-col
              v-else-if="isLockedAccessNotif(notif)"
              cols="8"
              class="d-flex flex-column justify-content-center pl-4 locked-notif"
              role="button"
              @click="onLockedFileNotifClick(notif)"
            >
              <div class="cell-content-wrapper">
                <div class="locked-notif__content">
                  <b-row
                    ><span class="notification-message-text">{{
                      notificationDisplayText(notif)
                    }}</span></b-row
                  >
                  <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
                </div>
                <div class="lock-overlay" role="status" aria-live="polite">
                  <b-icon-lock-fill class="mr-2" style="font-size: 1.1rem" />
                  <span>Locked - Assign token to view</span>
                </div>
              </div>
            </b-col>

            <!-- Type: Company Leaving Soon -->
            <b-col
              v-else-if="isCompanyLeaveNotif(notif)"
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              @click="onCancelCompanyLeave(notif)"
            >
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Type: Resource Updated -->
            <b-col
              v-else-if="notif.type === 'resourceupdatednotification'"
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              @click="onResourceNotifClick(notif)"
            >
              <b-row><span class="notif-sender">TradiePass</span></b-row>
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Type: Supervisor Timesheet Submitted / Resubmitted -->
            <b-col
              v-else-if="
                notif.type === 'supervisortimesheetsubmittednotification' ||
                notif.type === 'supervisortimesheetresubmittednotification'
              "
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              @click="onSupervisorTimesheetSubmittedClick(notif)"
            >
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Type: Supervisor Timesheet Rejected -->
            <b-col
              v-else-if="
                notif.type === 'supervisortimesheetrejectednotification'
              "
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              @click="onSupervisorTimesheetRejectedClick(notif)"
            >
              <b-row><span class="notif-sender">TradiePass</span></b-row>
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Type: Supervisor Timesheet Approved -->
            <b-col
              v-else-if="
                notif.type === 'supervisortimesheetapprovednotification'
              "
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              @click="onSupervisorTimesheetApprovedClick(notif)"
            >
              <b-row><span class="notif-sender">TradiePass</span></b-row>
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Type: OTW workforce invitation received (tradie-side) —
                 accept/decline right here, same pattern as
                 companyinvitenotification below, instead of forcing a trip
                 to Open to Work > Requests just to respond. -->
            <b-col
              v-else-if="
                notifOtwType(notif) === 'otw_workforce_invitation_received'
              "
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              @click="onOtwIncomingRequestClick(notif)"
            >
              <b-row><span class="notif-sender">TradiePass</span></b-row>
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
              <!-- prettier-ignore -->
              <b-row v-if="!notif.read" class="pt-1 justify-content-end" style="gap: 10px">
                <b-button class="slim" variant="success" :disabled="respondingInvitationId === notif.id" @click.stop="onRespondWorkforceInvitationNotif(notif, 'accepted')">Accept</b-button>
                <b-button class="slim" variant="danger" :disabled="respondingInvitationId === notif.id" @click.stop="onRespondWorkforceInvitationNotif(notif, 'declined')">Decline</b-button>
              </b-row>
            </b-col>

            <!-- Type: OTW resume request received (tradie-side) —
                 accept/decline right here, same pattern as the workforce
                 invitation above. Accept is gated on actually having a
                 resume on file, mirroring RequestsPage.vue's own
                 hasResume/acceptTooltip gate — accepting this is "yes,
                 here's my resume", which isn't a real answer with nothing to
                 hand over. -->
            <b-col
              v-else-if="notifOtwType(notif) === 'otw_resume_request_received'"
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              @click="onOtwIncomingRequestClick(notif)"
            >
              <b-row><span class="notif-sender">TradiePass</span></b-row>
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
              <!-- prettier-ignore -->
              <b-row v-if="!notif.read" class="pt-1 justify-content-end" style="gap: 10px">
                <span v-b-tooltip.hover="resumeAcceptTooltip" @click.stop>
                  <b-button class="slim" variant="success" :disabled="!hasResume || respondingResumeRequestId === notif.id" @click.stop="onRespondResumeRequestNotif(notif, 'accepted')">Accept</b-button>
                </span>
                <b-button class="slim" variant="danger" :disabled="respondingResumeRequestId === notif.id" @click.stop="onRespondResumeRequestNotif(notif, 'declined')">Decline</b-button>
              </b-row>
            </b-col>

            <!-- Type: OTW workforce invitation accepted (company-side) —
                 opens TokenConfirmationModal instead of navigating anywhere. -->
            <b-col
              v-else-if="
                notifOtwType(notif) === 'otw_workforce_invitation_accepted'
              "
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              @click="onOtwWorkforceInvitationAcceptedClick(notif)"
            >
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Type: OTW resume request accepted/declined, worker added,
                 workforce invitation declined, tradie reopened OTW
                 (company-side) — all just deep-link to the candidate's
                 profile, unlike workforce_invitation_accepted which opens
                 the token modal instead. -->
            <b-col
              v-else-if="
                notifOtwType(notif) === 'otw_resume_request_accepted' ||
                notifOtwType(notif) === 'otw_resume_request_declined' ||
                notifOtwType(notif) === 'otw_workforce_invitation_declined' ||
                notifOtwType(notif) === 'otw_worker_added' ||
                notifOtwType(notif) === 'otw_tradie_reopened'
              "
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              @click="onOtwCandidateNotifClick(notif)"
            >
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Type: scheduled job created/updated/reopened/cancelled/removed/
                 deleted — none of these carry a file, and a
                 cancelled/removed/deleted job can't be deep-linked to (the
                 row may already be gone), so all six just open the schedule
                 list instead of falling into the file-view fallback below. -->
            <b-col
              v-else-if="isJobScheduleNotif(notif)"
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              @click="goToSchedule(notif)"
            >
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Type: job application — a tradie applied (to the company) or
                 the company shortlisted / passed on an application (to the
                 tradie). Neither carries a file, so they open the job or the
                 tradie's applications instead of the file-view fallback. -->
            <b-col
              v-else-if="isJobApplicationNotif(notif)"
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              role="button"
              @click="goToJobApplication(notif)"
            >
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>

            <!-- Type: File Request and other file-related -->
            <b-col
              v-else
              cols="8"
              class="d-flex flex-column justify-content-center pl-4"
              type="button"
              @click="goToFile(notif)"
            >
              <b-row
                ><span class="notification-message-text">{{
                  notificationDisplayText(notif)
                }}</span></b-row
              >
              <b-row class="small gray--3">{{ uploaded(notif) }}</b-row>
            </b-col>
            <!-- <b-col v-if="notif.type !== 'companyinvitenotification'">
              <b-button
                variant="transparent"
                class="px-0 pt-0 pb-3"
                @click="markAsRead(notif)"
              >
                <b-icon icon="x" font-scale="1"></b-icon>
              </b-button>
            </b-col> -->
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </div>
    <div v-if="hasMultiplePages">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        align="center"
        class="mt-3 mb-0"
      />
    </div>
    <b-col
      v-if="filteredNotifications.length === 0"
      class="notifications__empty"
    >
      <b-row>
        <h3 class="font-weight-bold">No notifications yet!</h3>
      </b-row>
      <b-row>
        <h6 class="gray--3 text-center">
          We will notify you once we have something for you.
        </h6>
      </b-row>
    </b-col>
    <div>
      <notification-pop-up-modal
        v-model="showNotificationModal"
        :notification="selectedNotification"
        @closed="onMassNotificationModalClosed"
      />
      <assign-token-modal
        v-if="showAssignTokenModal && canAssignTokens"
        :showModal="showAssignTokenModal"
        :tradieToAssign="tradieToAssign"
        @closeModal="onAssignModalClose"
        @assign="onAssignToken"
        @purchaseTokens="onAssignModalPurchaseTokens"
      />
      <token-confirmation-modal
        v-if="showTokenConfirmationModal && canApplyOtwTokens"
        :showModal="showTokenConfirmationModal"
        :invitation="otwInvitationForModal"
        @closeModal="onTokenConfirmationModalClose"
        @apply="onApplyOtwToken"
        @dismiss="onDismissOtwToken"
        @purchaseTokens="onOtwTokenModalPurchaseTokens"
      />
      <purchase-token-modal
        v-if="canPurchaseTokens"
        :showModal="showPurchaseTokenModal"
        @closeModal="onPurchaseModalClose"
        @purchase="onPurchaseToken"
      />
    </div>
  </div>
</template>

<script>
import { canBuyTokens } from '@/utils/tokenAccess'
import { mapState, mapGetters, mapActions } from 'vuex'
import NotificationPopUpModal from '../modals/NotificationPopUpModal.vue'
import AssignTokenModal from '@/components/modals/AssignTokenModal'
import PurchaseTokenModal from '@/components/modals/PurchaseTokenModal'
import TokenConfirmationModal from '@/components/modals/TokenConfirmationModal'

export default {
  components: {
    NotificationPopUpModal,
    AssignTokenModal,
    PurchaseTokenModal,
    TokenConfirmationModal,
  },
  props: {
    hasBanner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showNotificationModal: false,
      selectedNotification: null,

      searchQuery: '',
      currentPage: 1,
      perPage: 10,

      noAccessActorIds: [],
      lockedFileIds: [],
      showAssignTokenModal: false,
      tradieToAssign: null,
      showPurchaseTokenModal: false,
      cancellingLeaveId: null,

      // OTW: workforce invitation accepted -> apply-token confirmation.
      showTokenConfirmationModal: false,
      otwInvitationForModal: null,

      // File Request notifications (esp. renewal requests) need two API
      // round trips before we know where to send the user — shows a
      // spinner over the row instead of leaving the click looking dead.
      loadingFileRequestId: null,

      // OTW: workforce invitation being accepted/declined inline from this
      // notification row (see onRespondWorkforceInvitationNotif) — disables
      // both buttons on that one row while the request is in flight.
      respondingInvitationId: null,
      // Same, for a resume request row (see onRespondResumeRequestNotif).
      respondingResumeRequestId: null,
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    ...mapGetters('notification', ['notifications']),
    ...mapGetters('token', ['canAccess']),
    ...mapGetters('auth', ['hasPermission']),

    // Mirrors RequestsPage.vue's own gate — accepting a resume request
    // needs an actual file to back it up.
    hasResume() {
      return !!(this.user && this.user.resume)
    },

    resumeAcceptTooltip() {
      if (this.hasResume) return { title: '', disabled: true }
      return {
        title: 'Upload a resume before you can accept a resume request.',
        disabled: false,
      }
    },

    canPurchaseTokens() {
      return canBuyTokens(this.user, this.hasPermission)
    },

    canAssignTokens() {
      return (
        (this.user && this.user.is_primary) ||
        this.hasPermission('settings.billing.assign')
      )
    },

    canApplyOtwTokens() {
      return (
        (this.user && this.user.is_primary) ||
        this.hasPermission('candidates.add_to_workforce')
      )
    },

    isTradieUser() {
      return this.user ? this.user.user_type === 'tradie' : false
    },

    isBusinessAdminUser() {
      return this.user ? this.user.user_type === 'business_admin' : false
    },

    isLockedTradie() {
      return this.isTradieUser && !this.canAccess
    },

    isBusinessAdminWithoutToken() {
      const u = this.user
      if (!u || u.user_type !== 'business_admin') return false
      const projectScoped =
        u.is_project_scoped === true ||
        (u.is_project_scoped == null && u.role === 'supervisor')
      return !u.has_token && !u.is_primary && !projectScoped && !u.is_free
    },

    filteredNotifications() {
      let list = this.notifications || []
      // filesharerevokednotification is always a personal "My Files"
      // peer-to-peer share revoke (see isFileAccessNotif's skip-list below,
      // which is a separate concern — click/fetch behavior, not visibility).
      // A business admin has no company-roster stake in it and it reads as
      // company/tradie-related in their context, so it's hidden entirely for
      // them. dismissHiddenBaFileShareRevokes() (created hook) marks any
      // hidden ones read so the bell badge doesn't get stuck.
      if (this.isBusinessAdminUser) {
        list = list.filter(
          (notif) => notif.type !== 'filesharerevokednotification',
        )
      }
      const q = (this.searchQuery || '').trim().toLowerCase()
      if (!q) return list
      return list.filter((notif) => {
        const text = this.notificationDisplayText(notif).toLowerCase()
        return text.includes(q)
      })
    },

    rows() {
      return this.filteredNotifications.length
    },

    hasMultiplePages() {
      return this.perPage > 0 && this.rows > this.perPage
    },

    pagedItems() {
      const start = (this.currentPage - 1) * this.perPage
      return this.filteredNotifications.slice(start, start + this.perPage)
    },
  },

  async created() {
    await this.prefetchNotifLockStatus()
    await this.dismissHiddenBaFileShareRevokes()
  },

  methods: {
    ...mapActions({
      getNotifications: 'notification/getNotifications',
      getUnreadNotifications: 'notification/getUnreadNotifications',
      getFile: 'file/getFile',
    }),
    ...mapActions('token', ['checkCanAccess']),
    ...mapActions('candidate', ['applyToken', 'dismissToken']),
    ...mapActions('tradieOtw', [
      'respondToWorkforceInvitation',
      'respondToResumeRequest',
    ]),

    // Laravel's own notif.type is the notification CLASS name, lowercased
    // with no separators (e.g. 'otwworkforceinvitationreceivednotification'
    // — confirmed straight from a live /notifications response). Every OTW
    // notification class instead embeds its own semantic snake_case type
    // string (e.g. 'otw_workforce_invitation_received') under data.type,
    // specifically for the frontend to match on. Every OTW v-else-if in
    // this file used to compare against notif.type directly and so never
    // matched anything — always silently falling through to the generic
    // file-request branch at the bottom, which is why these notifications
    // showed the right message text (notificationDisplayText reads
    // notif.data.message regardless) but never got their own icon, click
    // behaviour, or — for workforce invitations — Accept/Decline buttons.
    notifOtwType(notif) {
      if (!notif || typeof notif !== 'object') return null
      const d = notif.data && typeof notif.data === 'object' ? notif.data : null
      return (d && d.type) || null
    },

    // Company-originated notifications whose class name (see the note on
    // notif.type above notifOtwType) doesn't carry a hoisted data.type, so
    // they're matched directly against notif.type here. These are gated
    // behind isLockedTradie the same as mass/file-request notifications —
    // confirmed missing from that gate via a live token-removal test where
    // "made supervisor for project" and supervisor-timesheet notifications
    // still rendered their full content with no token.
    isTokenGatedCompanyNotif(notif) {
      if (!notif || typeof notif !== 'object') return false
      return [
        'supervisorassignednotification',
        'supervisorremovednotification',
        'supervisortimesheetupdatednotification',
        'supervisortimesheetsubmittedbybanotification',
        'supervisortimesheetsubmittednotification',
        'supervisortimesheetresubmittednotification',
        'supervisortimesheetrejectednotification',
        'supervisortimesheetapprovednotification',
        'supervisortimesheetrecallednotification',
        'supervisortimesheettradieaddednotification',
        'timesheeteventneedsapprovalnotification',
        'timesheeteventrejectednotification',
      ].includes(notif.type)
    },

    // Job application notifications hoist their type under data.type too:
    // 'job_application_received' (to the company) and 'job_application_status'
    // (to the tradie).
    isJobApplicationNotif(notif) {
      const type = this.notifOtwType(notif)
      return (
        type === 'job_application_received' || type === 'job_application_status'
      )
    },

    // ScheduledJob* notifications (see ScheduledJob*Notification::toArray()
    // in the API) hoist their semantic type the same way the OTW ones do.
    isJobScheduleNotif(notif) {
      if (!notif || typeof notif !== 'object') return false
      const d = notif.data && typeof notif.data === 'object' ? notif.data : null
      const type = d && d.type
      return [
        'job_created',
        'job_updated',
        'job_reopened',
        'job_cancelled',
        'job_removed',
        'job_deleted',
      ].includes(type)
    },

    // Extract the OTW workforce_invitation_id from a notification payload
    // (mirrors notifTradieId's best-effort shape handling above).
    notifWorkforceInvitationId(notif) {
      if (!notif || typeof notif !== 'object') return null
      const d = notif.data && typeof notif.data === 'object' ? notif.data : null
      const inner = d && d.data && typeof d.data === 'object' ? d.data : null
      const candidates = [
        inner && inner.workforce_invitation_id,
        d && d.workforce_invitation_id,
        notif.workforce_invitation_id,
      ]
      const first = candidates.find(
        (v) => v !== undefined && v !== null && v !== '',
      )
      if (first === undefined) return null
      const n = typeof first === 'string' ? parseInt(first, 10) : first
      return Number.isFinite(n) ? n : null
    },

    // Same shape, for resume_request_id.
    notifResumeRequestId(notif) {
      if (!notif || typeof notif !== 'object') return null
      const d = notif.data && typeof notif.data === 'object' ? notif.data : null
      const inner = d && d.data && typeof d.data === 'object' ? d.data : null
      const candidates = [
        inner && inner.resume_request_id,
        d && d.resume_request_id,
        notif.resume_request_id,
      ]
      const first = candidates.find(
        (v) => v !== undefined && v !== null && v !== '',
      )
      if (first === undefined) return null
      const n = typeof first === 'string' ? parseInt(first, 10) : first
      return Number.isFinite(n) ? n : null
    },

    notifOtwTradieName(notif) {
      if (!notif || typeof notif !== 'object') return null
      const d = notif.data && typeof notif.data === 'object' ? notif.data : null
      const inner = d && d.data && typeof d.data === 'object' ? d.data : null
      return (
        (inner && inner.tradie_name) ||
        (d && d.tradie_name) ||
        notif.tradie_name ||
        null
      )
    },

    // Company-side: rather than popping the token-apply modal in-place over
    // whatever page the BA happened to have this notification panel open
    // on, take them to Candidates > In Progress — the actual home for this
    // flow (same modal CandidateCard's own @apply-token opens there) — and
    // have that page open it automatically once it's loaded, via
    // InProgressPage.vue's openTokenModalFromQuery().
    onOtwWorkforceInvitationAcceptedClick(notif) {
      this.markAsRead(notif, false)
      const invitationId = this.notifWorkforceInvitationId(notif)
      if (invitationId == null) return
      const tradieId = this.notifTradieId(notif)
      const tradieName = this.notifOtwTradieName(notif)
      this.$router
        .push({
          name: 'candidates.in-progress-page',
          query: {
            applyTokenInvitationId: invitationId,
            ...(tradieId != null ? { applyTokenTradieId: tradieId } : {}),
            ...(tradieName ? { applyTokenTradieName: tradieName } : {}),
          },
        })
        .catch(() => {})
      this.$emit('close')
    },

    // Tradie-side: a company requested their resume. Nothing to act on
    // inline here (unlike the workforce invitation below) — accepting a
    // resume request needs the has-a-resume-on-file gate the Requests page
    // already renders, so just deep-link there.
    // Just navigating to go look at this — not a decision — so this
    // deliberately does NOT markAsRead(). Both this row's Accept/Decline
    // buttons (and RequestsPage.vue's own) are gated on !notif.read; if
    // clicking through to look marked it read, coming back to this panel
    // afterward without having actually accepted or declined would show the
    // row as resolved when nothing was decided, silently hiding the
    // buttons. Only onRespondWorkforceInvitationNotif/
    // onRespondResumeRequestNotif mark it read now, on an actual response.
    onOtwIncomingRequestClick(notif) {
      this.$router.push({ name: 'open-to-work.requests-page' }).catch(() => {})
      this.$emit('close')
    },

    // Tradie-side: accept/decline a workforce invitation right from this
    // notification row, same convention as onRespondInvite for
    // companyinvitenotification above.
    async onRespondWorkforceInvitationNotif(notif, status) {
      if (this.respondingInvitationId === notif.id) return
      const invitationId = this.notifWorkforceInvitationId(notif)
      if (invitationId == null) return

      this.respondingInvitationId = notif.id
      try {
        await this.respondToWorkforceInvitation({ id: invitationId, status })
        this.showToast(
          'Success',
          status === 'accepted'
            ? 'Workforce invitation accepted - you have joined this company.'
            : 'Workforce invitation declined.',
        )
        await this.markAsRead(notif, false)
      } catch (err) {
        const message =
          (err && err.data && err.data.message) ||
          'Unable to respond to this invitation.'
        this.showToast('Error', message, 'danger')
        // The invitation was already resolved some other way (e.g. via the
        // Requests page directly) while this notification stayed unread —
        // mark it read so a genuinely stale row like this doesn't keep
        // showing action buttons for something no longer actionable.
        if (/already been responded to/i.test(message)) {
          await this.markAsRead(notif, false)
        }
      } finally {
        this.respondingInvitationId = null
      }
    },

    // Same for a resume request — Accept is only enabled once hasResume is
    // true (button's own :disabled already blocks the click, but the
    // backend re-validates the same thing, so this still needs its own
    // error path for a stale row where a resume existed at render time but
    // was deleted before the click landed).
    async onRespondResumeRequestNotif(notif, status) {
      if (this.respondingResumeRequestId === notif.id) return
      if (status === 'accepted' && !this.hasResume) return
      const requestId = this.notifResumeRequestId(notif)
      if (requestId == null) return

      this.respondingResumeRequestId = notif.id
      try {
        await this.respondToResumeRequest({ id: requestId, status })
        this.showToast(
          'Success',
          status === 'accepted'
            ? 'Resume request accepted.'
            : 'Resume request declined.',
        )
        await this.markAsRead(notif, false)
      } catch (err) {
        const message =
          (err && err.data && err.data.message) ||
          'Unable to respond to this request.'
        this.showToast('Error', message, 'danger')
        if (/already been responded to/i.test(message)) {
          await this.markAsRead(notif, false)
        }
      } finally {
        this.respondingResumeRequestId = null
      }
    },

    onOtwCandidateNotifClick(notif) {
      this.markAsRead(notif, false)
      const tradieId = this.notifTradieId(notif)
      if (tradieId == null) return

      // 'otw_worker_added' only ever fires once a tradie is genuinely
      // active in the workforce (WorkforceInvitationService::applyToken()
      // dispatches it right after token_id/status=active land) — by then
      // CandidateProfileController::show() already excludes them (same
      // "already on this company's workforce" guard InProgressPage.vue's
      // goToCandidate() works around), so the candidate-profile route
      // 404s. Send this one type to the Tradies view instead; the other
      // four types sharing this handler (accepted/declined/reopened) don't
      // inherently imply the tradie is hired, so they keep the old target.
      if (this.notifOtwType(notif) === 'otw_worker_added') {
        this.$router
          .push({ name: 'tradies.view-tradie', params: { tradieId } })
          .catch(() => {})
        this.$emit('close')
        return
      }

      this.$router
        .push({
          name: 'candidates.view-candidate',
          params: { candidateId: tradieId },
        })
        .catch(() => {})
      this.$emit('close')
    },

    onTokenConfirmationModalClose() {
      this.showTokenConfirmationModal = false
      this.otwInvitationForModal = null
    },

    async onApplyOtwToken() {
      if (!this.otwInvitationForModal) return
      try {
        await this.applyToken(this.otwInvitationForModal.id)
        await this.$store.dispatch('token/getBalance')
        this.showTokenConfirmationModal = false
        this.otwInvitationForModal = null
        this.showToast(
          'Success',
          'Token applied - candidate added to your workforce.',
        )
      } catch (err) {
        this.showToast(
          'Error',
          (err && err.data && err.data.message) || 'Failed to apply token',
          'danger',
        )
      }
    },

    async onDismissOtwToken() {
      if (!this.otwInvitationForModal) return
      try {
        await this.dismissToken(this.otwInvitationForModal.id)
        this.showTokenConfirmationModal = false
        this.otwInvitationForModal = null
        this.showToast(
          'Saved',
          "We'll remind you - check Pending Token Applications to apply later.",
        )
      } catch (err) {
        this.showToast(
          'Error',
          (err && err.data && err.data.message) || 'Failed to save for later',
          'danger',
        )
      }
    },

    onOtwTokenModalPurchaseTokens() {
      this.showTokenConfirmationModal = false
      if (this.canPurchaseTokens) {
        this.showPurchaseTokenModal = true
      }
    },

    // Was missing entirely — every one of the ~11 showToast() calls in this
    // component (not just the ones below) was silently throwing
    // "this.showToast is not a function" inside catch blocks, so none of
    // them ever actually surfaced a toast.
    showToast(title, message, variant = 'success') {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 3000,
        variant: variant,
      })
    },

    fileSrc(notif) {
      return notif.type === 'expiringfilenotification'
        ? notif.data.data.type
          ? notif.data.data.object_thumbnail
          : notif.data.data.object_thumbnail
        : notif.actor_thumbnail
    },
    uploaded(notif) {
      return this.getTimeDiff(notif.created_at)
    },
    /**
     * Backend sends resource "ArchivedAdminLoginAttempt" or "ArchivedTradieLoginAttempt"
     * with id = user id (not file id). Must not route to file view.
     */
    isArchivedAdminLoginAttemptNotification(notif) {
      const d = notif && notif.data
      const inner = d && typeof d === 'object' ? d.data : null
      const resource = (inner && inner.resource) || (d && d.resource) || ''
      if (
        resource === 'ArchivedAdminLoginAttempt' ||
        resource === 'ArchivedTradieLoginAttempt' ||
        resource === 'ArchivedUserLoginAttempt'
      )
        return true
      const t = ((notif && notif.type) || '').toLowerCase()
      return (
        t.includes('archivedadminlogin') ||
        t.includes('archivedtradielogin') ||
        t.includes('archivedlogin') ||
        t === 'archived_admin_login_attempt' ||
        t === 'archived_tradie_login_attempt' ||
        t === 'archived_user_login_attempt'
      )
    },

    // Extract the tradie's user ID from a notification payload (best-effort).
    notifTradieId(notif) {
      if (!notif || typeof notif !== 'object') return null

      const d = notif.data && typeof notif.data === 'object' ? notif.data : null
      const inner = d && d.data && typeof d.data === 'object' ? d.data : null

      // Common backend shapes (seen across different notification resources)
      const candidates = [
        inner && inner.tradie_id,
        inner && inner.user_id,
        inner && inner.actor_id,
        d && d.tradie_id,
        d && d.user_id,
        d && d.actor_id,
        notif.tradie_id,
        notif.user_id,
        notif.actor_id,
        notif.actor && notif.actor.id,
      ]

      const first = candidates.find(
        (v) => v !== undefined && v !== null && v !== '',
      )
      if (first === undefined) return null

      const n = typeof first === 'string' ? parseInt(first, 10) : first
      return Number.isFinite(n) ? n : null
    },

    isSharedProjectNotif(notif) {
      if (!notif || typeof notif !== 'object') return false
      const d = notif.data && typeof notif.data === 'object' ? notif.data : null
      const inner = d && d.data && typeof d.data === 'object' ? d.data : null
      const resource = (inner && inner.resource) || (d && d.resource) || ''
      return resource === 'SharedProject'
    },

    // A project file (a document owned by a project) is about to expire / has
    // expired. Its payload `id` is a project-file id, NOT a tradie file id, so it
    // must never be treated as one (no file fetch, no token-gate lock).
    projectFileNotifData(notif) {
      if (!notif || typeof notif !== 'object') return null
      const d = notif.data && typeof notif.data === 'object' ? notif.data : null
      const inner = d && d.data && typeof d.data === 'object' ? d.data : null
      const payload = inner || d
      return payload && payload.resource === 'ProjectFile' ? payload : null
    },

    isProjectFileNotif(notif) {
      return this.projectFileNotifData(notif) !== null
    },

    // True if clicking this notification would attempt to load a specific file.
    isFileAccessNotif(notif) {
      if (this.isArchivedAdminLoginAttemptNotification(notif)) return false
      if (this.isSharedProjectNotif(notif)) return false
      if (this.isProjectFileNotif(notif)) return false
      if (this.isCompanyLeaveNotif(notif)) return false
      const skip = [
        'resumesharenotification',
        'filerequestnotification',
        'companyinviteacceptednotification',
        'companyinvitedeclinednotification',
        'companyinvitenotification',
        'notify',
        'mass_notification',
        'resourceupdatednotification',
        // A file shared/reshared to you is a peer-to-peer share, not a
        // company-roster file — it must never be subject to the BA
        // per-tradie token gate (see goToFile's 403 handling below).
        'filesharenotification',
        // Access is already gone by the time this notification exists —
        // there's nothing to fetch, so it must never hit the token gate.
        'filesharerevokednotification',
        // No 'id'-shaped file reference in its payload at all (see
        // TradieDisabledNotification::data() on the API) — nothing to check.
        'tradiedisablednotification',
        // Payload id is the company id, not a file id.
        'tradieleftcompanynotification',
      ]
      if (skip.includes(notif.type)) return false
      return this.notifFileId(notif) != null
    },

    // Extract file id from notification payload (best-effort across payload shapes).
    notifFileId(notif) {
      if (!notif || typeof notif !== 'object') return null
      const d = notif.data && typeof notif.data === 'object' ? notif.data : null
      const inner = d && d.data && typeof d.data === 'object' ? d.data : null

      const candidates = [
        inner && inner.id,
        inner && inner.file_id,
        inner && inner.object_id,
        d && d.id,
        d && d.file_id,
        d && d.object_id,
        notif.file_id,
        notif.object_id,
      ]

      const first = candidates.find(
        (v) => v !== undefined && v !== null && v !== '',
      )
      if (first === undefined) return null
      const n = typeof first === 'string' ? parseInt(first, 10) : first
      return Number.isFinite(n) ? n : null
    },

    isLockedFileNotif(notif) {
      if (!this.isBusinessAdminUser) return false
      if (!this.isFileAccessNotif(notif)) return false
      // Post-click detection
      const fileId = this.notifFileId(notif)
      if (fileId == null) return false
      if (this.lockedFileIds.includes(fileId)) return true
      // Proactive detection via prefetch
      const tradieId = this.notifTradieId(notif)
      return (
        tradieId != null && this.noAccessActorIds.includes(String(tradieId))
      )
    },

    isVisibilityAccessLostNotif(notif) {
      if (!this.isBusinessAdminUser) return false
      if (this.isSharedProjectNotif(notif)) return false
      if (this.isProjectFileNotif(notif)) return false
      const tradieId = this.notifTradieId(notif)
      if (
        tradieId == null ||
        !this.noAccessActorIds.includes(String(tradieId))
      ) {
        return false
      }

      return this.isVisibilityChangeMessage(notif)
    },

    isVisibilityChangeMessage(notif) {
      const msg = this.notificationDisplayText(notif)
      const text = (msg || '').toLowerCase()

      // Covers notifications like:
      // "made ... public" private" ... no longer have access ..."
      const mentionsVisibilityChange =
        text.includes('public') && text.includes('private')
      const mentionsAccessLost =
        text.includes('no longer have access') || text.includes('regain access')

      return mentionsVisibilityChange || mentionsAccessLost
    },

    isLockedAccessNotif(notif) {
      return (
        this.isLockedFileNotif(notif) || this.isVisibilityAccessLostNotif(notif)
      )
    },

    onLockedFileNotifClick(notif) {
      if (!this.canAssignTokens) return

      const tradieId = this.notifTradieId(notif)
      const tradie =
        (tradieId ? { id: tradieId } : null) ||
        this.$store.getters['company/tradie'] ||
        (localStorage.getItem('tradie_id')
          ? { id: parseInt(localStorage.getItem('tradie_id'), 10) }
          : null)
      this.tradieToAssign = tradie
      this.showAssignTokenModal = true
    },

    async checkTradieAccess(tradieId) {
      const companyId = this.user && this.user.company_id
      if (!companyId) return true
      try {
        const res = await this.$api.get('tokens/can-access', {
          params: { tradie_id: tradieId, company_id: companyId },
        })
        const d = res && res.data
        if (!d) return true
        if (d.can_access !== undefined) return !!d.can_access
        if (d.data && d.data.can_access !== undefined)
          return !!d.data.can_access
        return true
      } catch (e) {
        return false
      }
    },

    async prefetchNotifLockStatus() {
      if (!this.isBusinessAdminUser) return
      const tradieIds = new Set()
      for (const notif of this.notifications || []) {
        if (
          !this.isFileAccessNotif(notif) &&
          !this.isVisibilityChangeMessage(notif)
        )
          continue
        const tid = this.notifTradieId(notif)
        if (tid != null) tradieIds.add(String(tid))
      }
      if (!tradieIds.size) return
      const results = await Promise.all(
        [...tradieIds].map(async (tid) => ({
          tid,
          canAccess: await this.checkTradieAccess(tid),
        })),
      )
      for (const { tid, canAccess } of results) {
        if (!canAccess && !this.noAccessActorIds.includes(tid)) {
          this.noAccessActorIds.push(tid)
        }
      }
    },

    async onRespondInvite(notif, accepted) {
      await this.$api
        .put(`notifications/${notif.id}/accept-invite`, {
          accepted: accepted,
        })
        .then((r) => this.markAsRead(notif))
        .catch(() => {})
    },

    isCompanyLeaveNotif(notif) {
      if (!notif) return false
      const d = notif.data && typeof notif.data === 'object' ? notif.data : null
      const inner = d && d.data && typeof d.data === 'object' ? d.data : null
      const resource = (inner && inner.resource) || (d && d.resource) || ''
      return resource === 'Company' && !!(inner && inner.leave_at)
    },

    // BA-facing "a tradie is deleting their account" (vs a plain leave).
    isAccountDeletionNotif(notif) {
      const d =
        notif && notif.data && typeof notif.data === 'object'
          ? notif.data
          : null
      const inner = d && d.data && typeof d.data === 'object' ? d.data : null
      return !!(inner && inner.account_deletion)
    },

    notifCompanyId(notif) {
      if (!notif) return null
      const d = notif.data && typeof notif.data === 'object' ? notif.data : null
      const inner = d && d.data && typeof d.data === 'object' ? d.data : null
      const resource = (inner && inner.resource) || ''
      const id =
        (inner && inner.company_id) ||
        (d && d.company_id) ||
        notif.company_id ||
        (resource === 'Company' ? inner && inner.id : null) ||
        null
      if (id == null) return null
      const n = typeof id === 'string' ? parseInt(id, 10) : id
      return Number.isFinite(n) ? n : null
    },

    async onCancelCompanyLeave(notif) {
      const companyId = this.notifCompanyId(notif)
      if (!companyId) return

      // This notification also reaches business admins when one of their
      // tradies has a scheduled leave. It's the tradie's leave, not the
      // BA's, and we don't have a tradie id here to safely target a cancel
      // action against — so show it as read-only info instead of offering
      // a cancel action that isn't the BA's to take.
      if (this.isBusinessAdminUser) {
        const h = this.$createElement
        const tradieName = this.notifOtwTradieName(notif) || 'This tradie'
        const isDeletion = this.isAccountDeletionNotif(notif)
        const message = h('div', [
          isDeletion
            ? `${tradieName} is deleting their Tradie Pass account. Review the files they shared with your company and keep a copy of anything you are required or permitted to retain, or end the association now from the ending associations list. `
            : `${tradieName} has a scheduled leave from your company. Only the tradie can cancel it from their own account. `,
          'If you think this is incorrect, contact ',
          h(
            'a',
            {
              class: 'font-weight-bold',
              attrs: { href: 'mailto:support@tradiepass.com.au' },
            },
            'support@tradiepass.com.au',
          ),
          '.',
        ])
        await this.$bvModal.msgBoxOk([message], {
          title: isDeletion ? 'Account deletion' : 'Scheduled leave',
          okTitle: 'Got it',
          centered: true,
        })
        await this.markAsRead(notif, false)
        return
      }

      const ok = await this.$bvModal.msgBoxConfirm(
        'Cancel your scheduled leave from this company? The company will retain your information.',
        {
          title: 'Cancel leave?',
          okTitle: 'Yes, cancel leave',
          cancelTitle: 'Keep leave',
          okVariant: 'success',
          centered: true,
        },
      )
      if (!ok) return
      this.cancellingLeaveId = companyId
      try {
        const { data } = await this.$api.post('companies/cancel-leave', {
          company_id: companyId,
        })
        if (data && data.ok) {
          await this.markAsRead(notif, false)
          this.$root.$emit('refreshCompanyAssociations')
          this.showToast('Success', 'Leave cancelled.', 'success')
        } else {
          this.showToast(
            'Error',
            (data && data.message) || 'Unable to cancel leave.',
            'danger',
          )
        }
      } catch (err) {
        const msg =
          (err && err.data && err.data.message) || 'Unable to cancel leave.'
        this.showToast('Error', msg, 'danger')
      } finally {
        this.cancellingLeaveId = null
      }
    },

    // Every ScheduledJob* notification just opens the schedule list — a
    // cancelled/removed/deleted job's row may no longer exist (or no longer
    // include this worker), so there's nothing safe to deep-link to. The
    // /schedule route itself already redirects non-admin, non-supervisor
    // tradies home, so no extra access check is needed here.
    goToSchedule(notif) {
      this.markAsRead(notif)
      this.$router.push({ name: 'schedule.list-page' }).catch(() => {})
    },

    // A tradie's outcome opens their applications; a company's "new
    // application" opens that job (its applicants are on the job page).
    goToJobApplication(notif) {
      this.markAsRead(notif)
      // The ids sit under data.data (toDatabase() nests them); check both levels
      // like the OTW id helpers above.
      const data = (notif && notif.data) || {}
      const inner = data.data || {}
      const jobId = inner.job_posting_id || data.job_posting_id
      if (this.notifOtwType(notif) === 'job_application_status') {
        // Status updates (shortlisted, interview, offer, hired), "share your
        // contact details?" and "job updated" open the job itself. A closed
        // job can't be loaded on the job page, so that one stays on My
        // applications.
        const eventName = inner.event || data.event
        this.$router
          .push(
            jobId && eventName !== 'job_closed'
              ? { name: 'open-to-work.job-page', params: { jobId } }
              : { name: 'open-to-work.applications-page' },
          )
          .catch(() => {})
      } else if (jobId) {
        this.$router
          .push({ name: 'jobs.view-job', params: { jobId } })
          .catch(() => {})
      }
    },

    async goToFile(notif) {
      if (this.isArchivedAdminLoginAttemptNotification(notif)) {
        await this.markAsRead(notif)
        return
      }

      if (notif.type === 'filerequestnotification') {
        // Slow path: needs two API round trips (the file request, then the
        // file) before we know where to send the user. Keep the panel open
        // — with a spinner over this row — instead of racing markAsRead's
        // auto-close against the navigation, then close it ourselves once
        // goToFileRequest lands somewhere.
        this.markAsRead(notif, false)
        await this.goToFileRequest(notif)
        return
      }

      this.markAsRead(notif)

      if (notif.type === 'resumesharenotification') {
        this.$router
          .replace({
            name: 'tradies',
          })
          .catch(() => {})
      } else if (notif.type === 'companyinviteacceptednotification') {
        this.$router.replace({ name: 'tradies' })
      } else if (notif.type === 'companyinvitedeclinednotification') {
      } else if (notif.type === 'filesharerevokednotification') {
        // The message already explains what happened; there's no file left
        // to navigate to, so just mark it read (handled above).
      } else if (this.isSharedProjectNotif(notif)) {
        this.$router
          .replace({ name: 'projects.list-page', query: { tab: 'shared' } })
          .catch(() => {})
      } else if (this.isProjectFileNotif(notif)) {
        // Take them to the project, straight onto the Files tab where the
        // expiry badge is — not to a tradie file page.
        const projectId = this.projectFileNotifData(notif).project_id
        if (projectId == null) return
        this.$router
          .push({
            name: 'projects.view-page',
            params: { id: projectId },
            query: { tab: 'files' },
          })
          .catch(() => {})
      } else {
        const fileId = this.notifFileId(notif)
        if (fileId == null) return
        try {
          await this.getFile(fileId)
        } catch (err) {
          const status = err && err.response && err.response.status
          if (status === 403 && notif.type === 'filesharenotification') {
            // A share notification 403 means the share was revoked/cancelled,
            // or the account that shared it no longer exists — a peer-to-peer
            // access change either way, not a company-roster token gate.
            // Never route this into the assign/purchase-token flow.
            this.showToast(
              'No longer available',
              'This user no longer exists or has revoked access to this file. Please contact them to reshare.',
              'warning',
            )
          } else if (status === 403) {
            if (!this.lockedFileIds.includes(fileId)) {
              this.lockedFileIds.push(fileId)
            }
            this.onLockedFileNotifClick(notif)
          }
          // A 404 means the file has since been deleted (e.g. a tradie's
          // pending deletion ran out); the notification's message already says
          // what happened, so a click just does nothing.
          return
        }
        this.$router
          .replace({
            name: 'file.view-page',
            params: {
              id: fileId,
            },
            query: {
              from: 'notification',
              // Matches the "Shared With Me" list's own link so a file shared
              // to you opens in the same download-only restricted view either
              // way, instead of the full (owner-level) file view.
              ...(notif.type === 'filesharenotification'
                ? { shared: '1' }
                : {}),
            },
          })
          .catch(() => {})
      }
    },

    /**
     * A "File Request" notification's payload only carries the
     * file_request_user id (see FileRequestNotification::data() in the
     * API) — never the underlying file, so whether there's a file to jump
     * straight into editing can only be known after fetching the request.
     *
     * Business Admin "Request Renewal" (ExpiringTradieList.requestRenewal)
     * creates one of these requests with renewing_file_id set to the file
     * being renewed. Since that file already exists and belongs to this
     * notified tradie, skip the generic requests list and open it directly
     * in edit state. Any other file request (no prior file to renew) falls
     * back to the requests list, same as before, since the tradie still
     * needs to choose/create a file there.
     */
    async goToFileRequest(notif) {
      this.loadingFileRequestId = notif.id
      try {
        const fileRequestUserId = this.notifFileId(notif)
        if (fileRequestUserId != null) {
          try {
            await this.$store.dispatch(
              'requests/getRequestByUser',
              fileRequestUserId,
            )
            const request = this.$store.state.requests.request
            const renewingFileId =
              request &&
              request.file_request &&
              request.file_request.renewing_file_id

            if (renewingFileId != null) {
              await this.getFile(renewingFileId)
              this.$router
                .replace({
                  name: 'file.edit-page',
                  params: { id: renewingFileId },
                  // Tells EditFilePage this edit is to satisfy a renewal, so
                  // it can point the tradie at the Expiry Date field instead
                  // of leaving them to work out what actually needs changing.
                  query: { renewal: '1' },
                })
                .catch(() => {})
              return
            }
          } catch (err) {
            // Fall through to the requests list below.
          }
        }

        this.$router
          .replace({
            name: 'requests.list-page',
          })
          .catch(() => {})
      } finally {
        this.loadingFileRequestId = null
        this.$emit('close')
      }
    },

    async markAllAsRead() {
      try {
        await this.$api.put('notifications/read-all')
        await this.getNotifications()
        await this.$store.dispatch('notification/getUnreadNotifications')
      } catch (err) {
        this.showToast('Error', err.message, 'danger')
      }
    },

    async clearAllNotifications() {
      try {
        await this.$store.dispatch('notification/deleteAllNotifications')
      } catch (err) {
        this.showToast('Error', err.message, 'danger')
      }
    },

    async deleteNotification(notif) {
      try {
        await this.$store.dispatch('notification/deleteNotification', notif.id)
      } catch (err) {
        this.showToast('Error', err.message, 'danger')
      }
    },

    async markAsRead(notif, closeList = true) {
      await this.$api
        .put('notifications', {
          notification_id: notif.id,
        })
        .then(({ data }) => {
          if (data.success === true) {
            this.getNotifications()
            // The bell badge reads unreadNotifications, not notifications —
            // refresh it here too, not just on panel close, or the count
            // stays stale for every caller that marks a notif read while
            // keeping the panel open (closeList: false, most call sites).
            this.getUnreadNotifications()
            if (closeList) this.$emit('close')
          }
        })
    },

    // filteredNotifications hides filesharerevokednotification from BAs
    // entirely — since they can never see/click it, mark any unread ones
    // read on their behalf here, or the server-computed unread badge count
    // (notification/unreadCount, independent of the rendered list) would
    // stay stuck forever with no way for the BA to clear it.
    async dismissHiddenBaFileShareRevokes() {
      if (!this.isBusinessAdminUser) return
      const hidden = (this.notifications || []).filter(
        (notif) =>
          notif.type === 'filesharerevokednotification' && notif.read === false,
      )
      if (hidden.length === 0) return
      await Promise.all(
        hidden.map((notif) =>
          this.$api
            .put('notifications', { notification_id: notif.id })
            .catch(() => {}),
        ),
      )
      this.getNotifications()
      this.getUnreadNotifications()
    },

    onResourceNotifClick(notif) {
      this.markAsRead(notif, false)
      window.open(this.$env.cmsUrl + '/support/resources', '_blank')
    },

    onSupervisorTimesheetSubmittedClick(notif) {
      this.markAsRead(notif, false)
      const timesheetId =
        notif.data && notif.data.data && notif.data.data.supervisor_timesheet_id
      this.$router
        .replace({
          name: 'timesheets.list-page',
          query: { tab: 'supervisor', ...(timesheetId ? { timesheetId } : {}) },
        })
        .catch(() => {})
      this.$emit('close')
    },

    onSupervisorTimesheetRejectedClick(notif) {
      this.markAsRead(notif, false)
      const timesheetId =
        notif.data && notif.data.data && notif.data.data.supervisor_timesheet_id
      this.$router
        .replace({
          name: 'timesheets.list-page',
          query: {
            tab: 'my-submissions',
            ...(timesheetId ? { timesheetId } : {}),
          },
        })
        .catch(() => {})
      this.$emit('close')
    },

    onSupervisorTimesheetApprovedClick(notif) {
      this.markAsRead(notif, false)
      const timesheetId =
        notif.data && notif.data.data && notif.data.data.supervisor_timesheet_id
      this.$router
        .replace({
          name: 'timesheets.list-page',
          query: {
            tab: 'my-submissions',
            ...(timesheetId ? { timesheetId } : {}),
          },
        })
        .catch(() => {})
      this.$emit('close')
    },

    onMassNotificationClick(notif) {
      this.selectedNotification = notif
      this.showNotificationModal = true
    },

    onMassNotificationModalClosed() {
      if (
        this.selectedNotification &&
        this.selectedNotification.read === false
      ) {
        this.markAsRead(this.selectedNotification, false)
      }
      this.selectedNotification = null
    },

    async onAssignToken() {
      if (!this.tradieToAssign) return
      try {
        await this.$store.dispatch('token/assign', this.tradieToAssign.id)
        await this.$store.dispatch('token/getBalance')
        this.showAssignTokenModal = false
        this.tradieToAssign = null
        this.lockedFileIds = []
        this.noAccessActorIds = []
        this.showToast('Success', 'Token assigned successfully')
        this.prefetchNotifLockStatus()
      } catch (err) {
        this.showToast(
          'Error',
          (err && err.data && err.data.message) || 'Failed to assign token',
          'danger',
        )
      }
    },

    onAssignModalClose() {
      this.showAssignTokenModal = false
      this.tradieToAssign = null
    },

    onAssignModalPurchaseTokens() {
      this.showAssignTokenModal = false
      if (this.canPurchaseTokens) {
        this.showPurchaseTokenModal = true
      }
    },

    async onPurchaseToken(quantity) {
      if (!quantity || quantity < 1) return
      try {
        await this.$store.dispatch('token/purchase', quantity)
        await this.$store.dispatch('token/getBalance')
        this.showPurchaseTokenModal = false
        if (this.otwInvitationForModal) {
          this.showTokenConfirmationModal = true
        } else if (this.tradieToAssign) {
          this.showAssignTokenModal = true
        }
      } catch (err) {
        this.showToast(
          'Error',
          (err && err.data && err.data.message) || 'Failed to purchase tokens',
          'danger',
        )
      }
    },

    onPurchaseModalClose() {
      this.showPurchaseTokenModal = false
    },

    notificationDisplayText(notif) {
      const isMass =
        notif.type === 'notify' || notif.type === 'mass_notification'
      const d = notif.data

      if (isMass) {
        // Mass notification: prefer title
        if (notif.title) return notif.title
        if (notif.message) return notif.message
        if (d) {
          if (d.title) return d.title
          if (d.message) return d.message
        }
      } else {
        // All other types: prefer message
        if (d.message) return d.message
        if (d.title) return d.title
      }
      return ''
    },
  },

  watch: {
    searchQuery() {
      this.currentPage = 1
    },
    notifications() {
      this.prefetchNotifLockStatus()
      this.dismissHiddenBaFileShareRevokes()
    },
    user: {
      immediate: true,
      handler(newUser) {
        if (newUser && newUser.user_type === 'tradie') {
          this.checkCanAccess(newUser.id).catch(() => {
            // leave canAccess as default false on error
          })
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.notifications {
  &__container {
    position: fixed;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 10px 25px #00429d0d;
    border: 1px solid #b6c3d94d;
    border-top: none;
    border-radius: 8px 0px 0px 8px;
    opacity: 1;
    width: 400px;
    z-index: 1030;
    right: 0%;
    top: 88px;

    &--with-banner {
      top: 140px;

      @media (max-width: 767px) {
        top: 52px;
      }
    }

    @media (max-width: 767px) {
      top: 0;
      width: 85%;
      min-height: 100%;
      box-shadow: 0px 3px 5px #00429d0d;
      border: 0.5px solid #969eaa80;
      border-radius: 0;
    }
  }

  &__list {
    max-height: 82vh;
    overflow-y: visible;
    overflow-x: hidden;
  }

  &__empty {
    height: 85vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.list-group-item {
  border-top: none;
  border-left: none;
  border-right: none;

  &:hover,
  &:focus,
  &:active {
    background-color: #eaf3ff !important;
    color: #006cff !important;
  }
}

.unread {
  background-color: #eaf3ff !important;
  color: #006cff !important;
}

.unread-invite {
  background-color: #eafff7 !important;
  color: #077b0f !important;
}

.b-icon.bi {
  color: #b8bcc6;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar {
  width: 3.5em !important;
  height: 3.5em !important;
}

button.slim {
  height: fit-content;
  padding: 0px 8px;
}

/* Preserve \n from API message templates in the list (HTML collapses them by default). */
.notification-message-text {
  white-space: pre-line;
}

.notifications__container {
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 88px);
  padding-bottom: 1rem;
  box-sizing: border-box;

  &--with-banner {
    max-height: calc(100vh - 140px);
  }
}
.notifications__list {
  flex: 1 1 auto;
  min-height: 0; // lets flex child scroll
  overflow-y: auto;
  // remove or relax max-height: 82vh if it fights the flex layout
}

.locked-notif {
  position: relative;
  cursor: pointer;

  .cell-content-wrapper {
    position: relative;
  }

  &__content {
    opacity: 0.5;
    color: #999 !important;
    filter: blur(2px);
    user-select: none;
  }
}

.notif-locked {
  background-color: #f5f5f5 !important;
}

.notif-locked:hover,
.notif-locked:focus,
.notif-locked:active {
  background-color: #f5f5f5 !important;
  color: inherit !important;
}

.lock-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  pointer-events: none;
  font-size: 1.1rem;
  font-weight: 600;
  color: #6c757d;
  white-space: nowrap;
  opacity: 1;
  background: #f5f5f5;
  border: 1px solid #d7dce2;
  border-radius: 999px;
  padding: 0.28rem 0.65rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.lock-overlay .bi-lock-fill {
  color: #9aa3ad;
}

.notif-item {
  position: relative;
}

.notif-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.85);
  color: #006cff;
  font-size: 0.85rem;
  font-weight: 600;
  // Intentionally no pointer-events: none — sits on top to swallow clicks
  // on the row underneath while its request is in flight.
}

.notif-delete-btn {
  position: absolute;
  top: 6px;
  right: 8px;
  background: none;
  border: none;
  padding: 2px 4px;
  cursor: pointer;
  color: #adb5bd;
  line-height: 1;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.15s, color 0.15s;

  &:hover {
    color: #dc3545;
    background: #fff1f1;
  }
}

.notif-item:hover .notif-delete-btn {
  opacity: 1;
}

.notif-system-icon {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background: rgba(37, 99, 235, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;

  /deep/ .bi {
    color: #2563eb;
    font-size: 1.1rem;
  }
}

.notif-sender {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  color: #2563eb;
  text-transform: uppercase;
  letter-spacing: 0.01em;
  margin-bottom: 1px;
}
</style>
